<template>
  <div>
    <v-sheet :color="color + ' lighten-2'" class="px-2" elevation="2">
      <display-card-head
        :date="date"
        :icon="icon"
        :icon-tooltip="iconTooltip"
        :title="title"
      />
      <v-container class="pa-0">
        <v-row no-gutters>
          <v-sheet class="pa-1" color="text-background" width="100%">
            <p v-if="subtitle" class="font-weight-black">
              {{ subtitle }}
            </p>
            <u v-if="subsubtitle">
              {{ subsubtitle }}
            </u>
            <div style="white-space: pre-wrap;">{{ resume }}</div>
          </v-sheet>
        </v-row>
        <v-list-item class="grow" dense>
          <v-list-item-avatar size="25">
            <v-icon>person</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>
              <p class="text-break ma-0 font-italic font-weight-medium">
                {{ author }}
              </p>
            </v-list-item-title>
          </v-list-item-content>

          <v-row align="center" justify="end">
            <slot name="actions" />
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  class="mr-5"
                  icon
                  v-if="number_of_children > 0"
                  @click="handleShowMore"
                >
                  <v-badge
                    overlap
                    color="secondary"
                    :content="number_of_children"
                  >
                    <v-icon v-if="showChild" large>expand_less</v-icon>
                    <v-icon v-else large>expand_more</v-icon>
                  </v-badge>
                </v-btn>
              </template>
              <span class="ma-1">Afficher les évènements suivants</span>
            </v-tooltip>
          </v-row>
        </v-list-item>
      </v-container>
    </v-sheet>
    <v-expand-transition>
      <div v-if="showChild">
        <event-card
          class="my-1 mx-10 darken-2"
          v-for="child in children"
          :title="child.payload_type_description"
          :icon="icon"
          :color="color"
          :resume="child.resume"
          :date="child.entry_datetime"
          :author="`${child.author_name} (${child.author_type})`"
          :key="child.id"
        ></event-card>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import DisplayCardHead from '@/components/cards/DisplayCardHead';

export default {
  name: 'event-card',
  components: { DisplayCardHead },
  props: {
    children: {
      type: Array,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    author: {
      type: String,
      required: false,
    },
    subtitle: {
      type: String,
      required: false,
    },
    subsubtitle: {
      type: String,
      required: false,
    },
    iconTooltip: {
      type: String,
      required: false,
    },
    date: {
      type: Date,
      required: false,
    },
    resume: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    color: {
      type: String,
      required: false,
    },
  },
  computed: {
    number_of_children() {
      return this.children ? this.children.length : null;
    },
  },
  data() {
    return {
      showChild: false,
    };
  },
  methods: {
    handleShowMore() {
      this.showChild = !this.showChild;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
